/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import LineChart from "../Charts/LineChart";
import Typography from "@mui/material/Typography";
import moment from "moment";
import Skeleton from "@mui/material/Skeleton";
import { AppBar, Box, Grid, Grow } from "@mui/material";
import BarChart from "../Charts/BarChart";
import DonutChart from "../Charts/DonutChart";
import { useSelector } from "react-redux";
import Stackbar from "../Charts/StackBar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Draggable from "react-draggable";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Button, Tooltip } from "@mui/material";
import "./style.css";
import { Helmet } from "react-helmet-async";
import NotificationPop from "../../ui/Notification";
function PaperComponent(props) {
  return (
    <Draggable
      handle='#draggable-dialog-title'
      cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
export default function Analytics() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);
  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 2,
  });
  // ! FETCH ALL NEEDED INFOR HERE
  const tangibleAsset = useSelector((state) => state.assets);
  const category = useSelector((state) => state.category);
  const location = useSelector((state) => state.location);
  const intangibleAsset = useSelector((state) => state.intangible);
  const rightOfUse = useSelector((state) => state.rightOfUse);
  const today = new Date();
  const rightOfUseTotal = rightOfUse.filter(
    (d) => moment(d.exhaustion_date) > moment(today)
  );
  const categoryTotal = category.length;
  const locationTotal = location.length;
  const active = useSelector((state) => state.active);
  const exhausted = useSelector((state) => state.exhausted);
  const disposed = useSelector((state) => state.disposed);
  const disposedTotal = disposed.length;

  const disposedAmount = disposed.reduce((a, val) => a + val.cost, 0);
  const tangibleAssetTotal = tangibleAsset?.filter(
    (d) => d.category !== "intangibles" && d.category !== "right-of-use asset"
  );
  const totalAssets =
    tangibleAssetTotal.length + intangibleAsset.length + rightOfUseTotal.length;

  const allAsset = [
    ...tangibleAssetTotal,
    ...intangibleAsset,
    ...rightOfUseTotal,
  ];

  const allCostTotal = allAsset.reduce((acc, val) => acc + val.cost, 0);
  const allAccumTotal = allAsset.reduce((acc, val) => acc + val.accum_depre, 0);
  const allCarryingAmount = allAsset.reduce(
    (acc, val) => acc + val.carrying_amount,
    0
  );
  const intangibleCat = [
    {
      asset_pool: "INTANGIBLES",
      code: "IA",
      intangible_category: "true",
      id: "6463e2c9b03c40ecfc0c8bm2",
    },
  ];
  const newCategory = [...category, ...intangibleCat];
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const [labelName, setLabelName] = React.useState("");
  const handleClose = () => {
    setOpen(false);
    setLabelName("");
  };
  const [dataShow, setData] = React.useState([]);
  React.useEffect(() => {
    if (labelName !== "") {
      handleModal();
    }
  }, [labelName]);
  // Example usage:
  function handleModal() {
    if (labelName === "all assets") {
      setData(allAsset);
    }
    if (labelName === "pools") {
      setData(newCategory);
    }
    if (labelName === "locations") {
      const updatedArray = location.map((obj) => {
        const { _id, ...rest } = obj;
        return { id: _id, ...rest };
      });
      setData(updatedArray);
    }
    if (labelName === "disposed") {
      const updatedArray = disposed.map((obj) => {
        const { _id, ...rest } = obj;
        return { id: _id, ...rest };
      });
      setData(updatedArray);
    }
    if (labelName === "exhausted") {
      const updatedArray = exhausted.map((obj) => {
        const { _id, ...rest } = obj;
        return { id: _id, ...rest };
      });
      setData(updatedArray);
    }
    if (labelName === "active") {
      const updatedArray = active.map((obj) => {
        const { _id, ...rest } = obj;
        return { id: _id, ...rest };
      });
      setData(updatedArray);
    }

    handleClickOpen();
  }
  const columns = Object.keys(dataShow[0] || {})
    .filter((key) => key !== "id")
    .map((key) => ({
      field: key,
      headerName: key,
      minWidth: 170,
      align: "left",
    }));
  return (
    <Box>
      <div
        style={{
          display: "flex",
          alignContent: "center",
          justifyContent: "center",
        }}>
        <Helmet title='Dashboard | Assets Register' />

        <Paper
          elevation={3}
          sx={{
            backgroundColor: `${mode === "dark" ? "#101418" : "#D7DED0"}`,
            padding: "10px",
            borderRadius: "15px",
            width: "fit-content",
            border: "1px solid #3D4F58",
          }}>
          <Grid spacing={2} sx={{ flexGrow: 1 }}>
            <Grid item xs={12}>
              <Grid container justifyContent='center' spacing={1}>
                <Tooltip title='click to view data'>
                  <Grow in timeout={1000}>
                    <Grid item>
                      {totalAssets ? (
                        <Card
                          onClick={() => setLabelName("all assets")}
                          sx={{
                            maxWidth: 280,
                            height: 60,
                            cursor: "pointer",
                            backgroundColor: `${
                              mode === "dark" ? "#13171B" : "#DCDCDC"
                            }`,
                            alignItems: "center",
                            borderLeft: `5px solid ${
                              mode === "dark" ? "#0883FF" : "#17B859"
                            }`,
                          }}>
                          <CardContent>
                            <Typography
                              component='div'
                              variant='body2'
                              color={`${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000000"
                              }`}
                              style={{
                                // marginBottom: "30px",
                                display: "flex",
                                flexDirection: "column",

                                alignItems: "center",
                                fontSize: "11px",
                                color: `${
                                  mode === "dark"
                                    ? "rgba(255,255,255,0.65)"
                                    : "#000000"
                                }`,
                                //
                              }}>
                              TOTAL ASSETS
                            </Typography>
                            <div>
                              <Typography
                                variant='body2'
                                color={`${
                                  mode === "dark"
                                    ? "rgba(255,255,255,0.65)"
                                    : "#000000"
                                }`}>
                                {currencyFormatter.format(totalAssets)}
                              </Typography>
                            </div>
                          </CardContent>
                        </Card>
                      ) : (
                        <Skeleton variant='rounded' width={200} height={60} />
                      )}
                    </Grid>
                  </Grow>
                </Tooltip>
                <Tooltip title='click to view data'>
                  <Grow in timeout={1500}>
                    <Grid item>
                      {categoryTotal ? (
                        <Card
                          onClick={() => setLabelName("pools")}
                          sx={{
                            maxWidth: 345,
                            height: 60,
                            cursor: "pointer",
                            backgroundColor: `${
                              mode === "dark" ? "#13171B" : "#DCDCDC"
                            }`,
                            alignItems: "center",
                            borderLeft: `5px solid ${
                              mode === "dark" ? "#0883FF" : "#17B859"
                            }`,
                          }}>
                          <CardContent>
                            <Typography
                              component='div'
                              variant='body2'
                              color={`${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000000"
                              }`}
                              style={{
                                // marginBottom: "30px",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                fontSize: "11px",
                                color: `${
                                  mode === "dark"
                                    ? "rgba(255,255,255,0.65)"
                                    : "#000000"
                                }`,
                              }}>
                              TOTAL ASSETS POOLS
                            </Typography>

                            <Typography
                              variant='body2'
                              color={`${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000000"
                              }`}>
                              {currencyFormatter.format(categoryTotal + 1)}
                            </Typography>
                          </CardContent>
                        </Card>
                      ) : (
                        <Skeleton variant='rounded' width={200} height={60} />
                      )}
                    </Grid>
                  </Grow>
                </Tooltip>
                <Tooltip title='click to view data'>
                  <Grow in timeout={2000}>
                    <Grid item>
                      {locationTotal ? (
                        <Card
                          onClick={() => setLabelName("locations")}
                          sx={{
                            maxWidth: 345,
                            height: 60,
                            cursor: "pointer",
                            backgroundColor: `${
                              mode === "dark" ? "#13171B" : "#DCDCDC"
                            }`,
                            alignItems: "center",
                            borderLeft: `5px solid ${
                              mode === "dark" ? "#0883FF" : "#17B859"
                            }`,
                          }}>
                          <CardContent>
                            <Typography
                              component='div'
                              variant='body2'
                              color={`${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000000"
                              }`}
                              style={{
                                // marginBottom: "30px",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                fontSize: "11px",
                                color: `${
                                  mode === "dark"
                                    ? "rgba(255,255,255,0.65)"
                                    : "#000000"
                                }`,
                              }}>
                              LOCATIONS
                            </Typography>

                            <Typography
                              variant='body2'
                              color={`${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000000"
                              }`}>
                              {currencyFormatter.format(locationTotal)}
                            </Typography>
                          </CardContent>
                        </Card>
                      ) : (
                        <Skeleton variant='rounded' width={200} height={60} />
                      )}
                    </Grid>
                  </Grow>
                </Tooltip>
                <Tooltip title={"click to view data"}>
                  <Grow in timeout={2500}>
                    <Grid item>
                      {disposedTotal >= 0 ? (
                        <Card
                          onClick={() => setLabelName("disposed")}
                          sx={{
                            maxWidth: 345,
                            height: 60,
                            cursor: "pointer",
                            backgroundColor: `${
                              mode === "dark" ? "#13171B" : "#DCDCDC"
                            }`,
                            alignItems: "center",
                            borderLeft: "5px solid #d33115",
                          }}>
                          <CardContent>
                            <Typography
                              component='div'
                              variant='body2'
                              color={`${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000000"
                              }`}
                              style={{
                                // marginBottom: "30px",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                fontSize: "11px",
                                color: `${
                                  mode === "dark"
                                    ? "rgba(255,255,255,0.65)"
                                    : "#000000"
                                }`,
                              }}>
                              DISPOSED ASSETS
                            </Typography>

                            <Typography
                              variant='body2'
                              color={`${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000000"
                              }`}>
                              <span style={{ fontSize: "11px" }}>
                                Total: {disposedTotal}
                              </span>{" "}
                              <span style={{ fontSize: "11px" }}>
                                Cost:{currencyFormatter.format(disposedAmount)}
                              </span>
                            </Typography>
                          </CardContent>
                        </Card>
                      ) : (
                        <Skeleton variant='rounded' width={200} height={60} />
                      )}
                    </Grid>
                  </Grow>
                </Tooltip>

                <Grow in timeout={3500}>
                  <Grid item>
                    {allCostTotal ? (
                      <Card
                        sx={{
                          maxWidth: 345,
                          height: 60,
                          // backgroundColor: "grey",
                          alignItems: "center",
                          backgroundColor: `${
                            mode === "dark" ? "#13171B" : "#DCDCDC"
                          }`,
                          borderLeft: `5px solid ${
                            mode === "dark" ? "#0883FF" : "#17B859"
                          }`,
                        }}>
                        <CardContent>
                          <Typography
                            component='div'
                            variant='body2'
                            color={`${
                              mode === "dark"
                                ? "rgba(255,255,255,0.65)"
                                : "#000000"
                            }`}
                            style={{
                              // marginBottom: "30px",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              fontSize: "11px",
                              color: `${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000000"
                              }`,
                            }}>
                            TOTAL COST
                          </Typography>

                          <Typography
                            variant='body2'
                            color={`${
                              mode === "dark"
                                ? "rgba(255,255,255,0.65)"
                                : "#000000"
                            }`}>
                            GHS {currencyFormatter.format(allCostTotal)}
                          </Typography>
                        </CardContent>
                      </Card>
                    ) : (
                      <Skeleton variant='rounded' width={200} height={60} />
                    )}
                  </Grid>
                </Grow>
                <Grow in timeout={4000}>
                  <Grid item>
                    {allAccumTotal ? (
                      <Card
                        sx={{
                          maxWidth: 345,
                          cursor: "pointer",
                          height: 60,
                          // backgroundColor: "#DDCECD",
                          alignItems: "center",
                          backgroundColor: `${
                            mode === "dark" ? "#13171B" : "#DCDCDC"
                          }`,
                          borderLeft: `5px solid ${
                            mode === "dark" ? "#0883FF" : "#17B859"
                          }`,
                        }}>
                        <CardContent>
                          <Typography
                            component='div'
                            variant='body2'
                            color={`${
                              mode === "dark"
                                ? "rgba(255,255,255,0.65)"
                                : "#000000"
                            }`}
                            style={{
                              // marginBottom: "30px",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              fontSize: "11px",

                              color: `${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000000"
                              }`,
                            }}>
                            ACCUM. DEPN
                          </Typography>

                          <Typography
                            variant='body2'
                            color={`${
                              mode === "dark"
                                ? "rgba(255,255,255,0.65)"
                                : "#000000"
                            }`}>
                            {currencyFormatter.format(allAccumTotal)}
                          </Typography>
                        </CardContent>
                      </Card>
                    ) : (
                      <Skeleton variant='rounded' width={200} height={60} />
                    )}
                  </Grid>
                </Grow>
                <Grow in timeout={4000}>
                  <Grid item>
                    {allCarryingAmount ? (
                      <Card
                        sx={{
                          maxWidth: 345,
                          height: 60,
                          alignItems: "center",
                          cursor: "pointer",
                          backgroundColor: `${
                            mode === "dark" ? "#13171B" : "#DCDCDC"
                          }`,
                          borderLeft: `5px solid ${
                            mode === "dark" ? "#0883FF" : "#17B859"
                          }`,
                        }}>
                        <CardContent>
                          <Typography
                            component='div'
                            variant='body2'
                            color={`${
                              mode === "dark"
                                ? "rgba(255,255,255,0.65)"
                                : "#000000"
                            }`}
                            style={{
                              // marginBottom: "30px",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              fontSize: "11px",
                            }}>
                            CARRYING AMOUNT
                          </Typography>

                          <Typography
                            variant='body2'
                            color={`${
                              mode === "dark"
                                ? "rgba(255,255,255,0.65)"
                                : "#000000"
                            }`}>
                            {currencyFormatter.format(allCarryingAmount)}
                          </Typography>
                        </CardContent>
                      </Card>
                    ) : (
                      <Skeleton variant='rounded' width={200} height={60} />
                    )}
                  </Grid>
                </Grow>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </div>

      <Paper
        elevation={0}
        style={{
          backgroundColor: `${mode === "dark" ? "#101418" : "#D7DED0"}`,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "10px",
          margin: "10px",
          paddingBottom: "5px",
          borderRadius: "20px",
          border: "1px solid #a5aba0",
        }}>
        <BarChart />
        <DonutChart />
      </Paper>

      <div
        style={{
          paddingBottom: "100px",
          borderRadius: "20px",
        }}>
        <LineChart />
      </div>

      <Grow in timeout={2000}>
        <AppBar
          position='fixed'
          elevation={0}
          style={{
            backgroundColor: `${mode === "dark" ? "#101418" : "#E4EADC"}`,
          }}
          sx={{ top: "auto", bottom: 0 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginLeft: "180px",
            }}>
            <Stackbar />
          </div>
        </AppBar>
      </Grow>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'>
        <DialogTitle style={{ cursor: "move" }} id='draggable-dialog-title'>
          {labelName}
        </DialogTitle>
        <DialogContent>
          <Paper>
            <DataGrid
              columns={columns}
              getRowId={(row) => row.id}
              rows={dataShow}
              slots={{ toolbar: GridToolbar }}
              style={{ height: "50vh" }}
              disableRowSelectionOnClick
            />
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <NotificationPop />
    </Box>
  );
}
